import {
  ThemeColor,
  ThemeMode,
  ThemeSettings,
} from "@/types/ApiResponses/UserPreferences";

// Canonical mode → { mode, color } pairing, shared by EVERY light/dark toggle
// (Zero's ZeroThemeSwitch, the default theme's ThemeToggle and Zero's
// first-visit dark default): light pairs with green, dark with yellow. Flipping
// the mode anywhere resets the accent to this rule; the 3-swatch
// AccentColorSwitcher remains a manual override until the next mode flip.
export const getThemeSettingsForMode = (mode: ThemeMode): ThemeSettings => ({
  mode,
  color: mode === ThemeMode.Dark ? ThemeColor.Yellow : ThemeColor.Green,
});
